/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'burger': {
    width: 33.277,
    height: 22,
    viewBox: '0 0 33.277 22',
    data: '<g data-name="Groupe 193" _fill="none" _stroke="#766e6a" stroke-linecap="round" stroke-width="2"><path pid="0" data-name="Ligne 8" d="M32.277 1H1"/><path pid="1" data-name="Ligne 9" d="M32.277 11H1"/><path pid="2" data-name="Ligne 10" d="M32.277 21H1"/></g>'
  }
})
